import { TypeEventEnum } from 'app/api/event/model'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import {
  disabledEndDate,
  disabledStartDate,
  disabledTimeEnd,
  disabledTimeStart,
} from 'app/hook'
import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { EventStatusEnum, IFilterEventList } from '../../type'

interface IProps {
  onChangeFilter?: (filter: IFilterEventList) => void
  filter?: IFilterEventList
}

export const FilterLayout: React.FC<IProps> = ({ filter, onChangeFilter }) => {
  const { t } = useTranslation()

  const onChangeSearch = (value: string) => {
    onChangeFilter?.({ ...filter, search: value })
  }

  const onChangeStatus = (value: EventStatusEnum[]) => {
    onChangeFilter?.({ ...filter, status: value })
  }

  const onChangeType = (value: TypeEventEnum[]) => {
    onChangeFilter?.({ ...filter, type: value })
  }

  return (
    <BaseForm>
      <BaseRow gutter={[16, 8]}>
        <BaseCol xl={4}>
          <BaseFormItem hiddenLabel>
            <BaseInput
              placeholder={t(R.strings.search)}
              value={filter?.search}
              onChange={e => onChangeSearch?.(e?.target?.value)}
              allowClear
            />
          </BaseFormItem>
        </BaseCol>

        <BaseCol xl={5}>
          <BaseFormItem hiddenLabel>
            <BaseSelect
              mode="multiple"
              placeholder={'Tất cả trạng thái'}
              options={[
                {
                  label: t(R.strings.not_open_register),
                  value: EventStatusEnum.NOT_OPEN,
                },
                {
                  label: t(R.strings.registration),
                  value: EventStatusEnum.REGISTRATION,
                },
                {
                  label: t(R.strings.registration_completed),
                  value: EventStatusEnum.REGISTRATION_COMPLETED,
                },
                {
                  label: t(R.strings.in_event),
                  value: EventStatusEnum.IN_PROGRESS,
                },
                {
                  label: t(R.strings.finished),
                  value: EventStatusEnum.FINISHED,
                },
              ]}
              onChange={value => onChangeStatus(value as EventStatusEnum[])}
              allowClear
            />
          </BaseFormItem>
        </BaseCol>

        <BaseCol xl={5}>
          <BaseFormItem hiddenLabel>
            <BaseSelect
              mode="multiple"
              placeholder={'Tất cả loại sự kiện'}
              options={[
                {
                  label: 'Nhóm Tập huấn - Hội thảo - Đào tạo',
                  value: TypeEventEnum.TRAINING,
                },
                {
                  label: 'Nhóm Thông tin',
                  value: TypeEventEnum.NEWS,
                },
                {
                  label: 'Nhóm Hoạt động cấp trên',
                  value: TypeEventEnum.SUPERIOR_GROUP,
                },
                {
                  label: 'Nhóm Khác',
                  value: TypeEventEnum.OTHER,
                },
                {
                  label: 'Nhóm Hội thi - Phong trào thi đua',
                  value: TypeEventEnum.ACTIVITY,
                },
                {
                  label: 'Nhóm Hoạt động chăm lo',
                  value: TypeEventEnum.CARE,
                },
              ]}
              onChange={value => onChangeType(value as TypeEventEnum[])}
              allowClear
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={5}>
          <BaseFormItem hiddenLabel>
            <BaseDatePickerStyled
              format={'DD-MM-YYYY HH:mm'}
              placeholder={t(R.strings.start_date_event)}
              showTime={{ defaultValue: dayjs('00:00', 'HH:mm') }}
              onChange={value =>
                onChangeFilter?.({
                  ...filter,
                  startDateDayJs: value,
                })
              }
              disabledDate={e => disabledStartDate(e, filter?.endDateDayJs)}
              disabledTime={e => disabledTimeStart(e, filter?.endDateDayJs)}
              allowClear
            />
          </BaseFormItem>
        </BaseCol>

        <BaseCol xl={5}>
          <BaseFormItem hiddenLabel>
            <BaseDatePickerStyled
              format={'DD-MM-YYYY HH:mm'}
              placeholder={t(R.strings.end_date_event)}
              showTime={{ defaultValue: dayjs('23:59', 'HH:mm') }}
              onChange={value =>
                onChangeFilter?.({
                  ...filter,
                  endDateDayJs: value,
                })
              }
              disabledDate={e => disabledEndDate(e, filter?.startDateDayJs)}
              disabledTime={e => disabledTimeEnd(e, filter?.startDateDayJs)}
              allowClear
            />
          </BaseFormItem>
        </BaseCol>
      </BaseRow>
    </BaseForm>
  )
}

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px;
`

const BaseDatePickerStyled = styled(BaseDatePicker)`
  width: 100%;
`
